export const announementsData = [
    {
        _id: 1,
        title: "There will be quiz next week from chapter 1-2",
        date: "5/25/2023",
        comments: [{
            studentID: "STD_123",
            studentName: "Jhon",
            comment: "Sir please extand the date.",
            date: "5/26/2023",
        },
        {
            studentID: "STD_890",
            studentName: "Sophia",
            comment: "ok Sir ",
            date: "5/26/2023",
        }]
    }
] 